export default __webpack_public_path__ + "static/media/image-zx7.4601003a.jpg";